import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Metrics } from '../Themes'

const Container = styled.section`
  padding-left: calc((100% - ${Metrics.grid.desktop})/2);
  padding-right: calc((100% - ${Metrics.grid.desktop})/2);
  padding-bottom: ${Metrics.margins.base};
  ${props => props.customStyle};

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    padding-left: calc((100% - ${Metrics.grid.tablet})/2);
    padding-right: calc((100% - ${Metrics.grid.tablet})/2);
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding-left: ${Metrics.components.themeMobileMargins};
    padding-right: ${Metrics.components.themeMobileMargins};
  }

  @media screen and (min-width: ${Metrics.breakpoints.giant}) {
    padding-left: calc((100% - ${Metrics.grid.giant})/2);
    padding-right: calc((100% - ${Metrics.grid.giant})/2);
  }
`

const ThemeContainer = props => {
  const { children } = props
  return <Container {...props}>{children}</Container>
}

ThemeContainer.propTypes = {
  children: PropTypes.node,
  customStyle: PropTypes.node
}

export default ThemeContainer



// WEBPACK FOOTER //
// ./src/components/ThemeContainer.js